import { on, hash } from '../utils'
import { translateService } from '../service/TranslateService'

class LangTemplate {
	name
	template
	getHtml (name, active) {
		return /* html */ `
		<li  ${on('click', translateService, 'translate', name)}
			class="nav-item"
			href=''
		><button class="nav-link flag nturl notranslate google-translate__lang ${active == name ? 'active ' : ' '}" id="lang-${name}">${name}</button>
		</li>
		`
	}
}

const langTemplate = new LangTemplate()
export {
	LangTemplate,
	langTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/template/LangTemplate.js